import { useMemo } from 'react'
import { flattenProp } from 'recompose'
import { setActiveLocation } from 'map/actions'
import * as selectors from 'map/selectors'
import Pin from '@components/Pin'
import Popover from 'map/components/popover/CarParkPopover'
import MarkerRateCounter from 'map/components/markers/MarkerRateCounter'
import featureToggles from 'shared/featureToggles'

import { THEME, ENV_THEME } from 'map/helpers'

const getTheme = (opngo, brand) =>
    opngo ? THEME.OPENGO : brand && brand.toLowerCase() === THEME.WESTPARK ? THEME.WESTPARK : ENV_THEME

const Marker = ({
    location: { brand, externalSeasonTicketUrl, geoLocation, reservationsEnabled },
    setActiveLocation,
    sfLocationId,
    bookingUrl,
    carParkUrl,
    monthlyParkingUrl,
    redirectToMonthlyParkingFlow,
    buyLabel,
    hovered,
    canBuy,
    active,
    faded,
    opngo,
    name,
    rate,
    searchMode,
    style,
}) => {
    const isUnbookable = useMemo(
        () => !canBuy && !opngo && !externalSeasonTicketUrl,
        [canBuy, opngo, externalSeasonTicketUrl]
    )

    const onClickPin = () => {
        setActiveLocation(sfLocationId, false, { lat: geoLocation.x, lng: geoLocation.y })
    }

    return (
        <div style={style}>
            {active && (
                <Popover
                    name={name}
                    canBuy={canBuy}
                    bookingUrl={bookingUrl}
                    buyLabel={buyLabel}
                    carParkUrl={carParkUrl}
                    opngo={opngo}
                    externalSeasonTicketUrl={externalSeasonTicketUrl}
                    searchMode={searchMode}
                    reservationsEnabled={reservationsEnabled}
                    monthlyParkingUrl={monthlyParkingUrl}
                    redirectToMonthlyParkingFlow={redirectToMonthlyParkingFlow}
                    rate={rate}
                />
            )}
            <Pin
                faded={faded}
                hovered={hovered}
                active={active}
                theme={getTheme(opngo, brand)}
                bookable={!isUnbookable}
                onClick={onClickPin}
                name={name}>
                <MarkerRateCounter opngo={opngo} canBuy={canBuy} rate={rate} />
            </Pin>
        </div>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            location: selectors.locationSelector,
            active: selectors.isActiveSelector,
            hovered: selectors.isHoveredSelector,
            bookingUrl: selectors.bookingUrlSelector,
            carParkUrl: selectors.carParkUrlSelector,
            canBuy: selectors.canBuySelector,
            buyLabel: selectors.buyLabelTranslationSelector,
            rate: selectors.rateLabelSelector,
            searchMode: selectors.searchModeSelector,
            monthlyParkingUrl: selectors.monthlyParkingUrlSelector,
            redirectToMonthlyParkingFlow: selectors.redirectToMonthlyParkingFlowSelector,
        }),
        { setActiveLocation }
    ),
    flattenProp('location')
)(Marker)
